import React, { useState, useEffect } from 'react';
import { useTranslation } from '../LanguageContext';

function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openItem, setOpenItem] = useState(null);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('openFaq', handler);
    return () => window.removeEventListener('openFaq', handler);
  }, []);

  const items = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
    { q: t('faq.q6'), a: t('faq.a6') },
    { q: t('faq.q7'), a: t('faq.a7') },
    { q: t('faq.q8'), a: t('faq.a8') },
    { q: t('faq.q9'), a: t('faq.a9') },
    { q: t('faq.q10'), a: t('faq.a10') },
    { q: t('faq.q11'), a: t('faq.a11') },
  ];

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          background: '#6b0f3a',
          color: '#fff',
          border: 'none',
          fontSize: '20px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
          zIndex: 900,
          lineHeight: '44px',
          padding: 0,
        }}
        title={t('faq.title')}
        aria-label={t('faq.title')}
      >
        ?
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: '12px',
              maxWidth: '520px',
              width: '100%',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '28px 24px 24px',
              position: 'relative',
            }}
          >
            <button
              onClick={() => setOpen(false)}
              style={{
                position: 'absolute',
                top: '14px',
                right: '16px',
                background: 'none',
                border: 'none',
                fontSize: '22px',
                cursor: 'pointer',
                color: '#888',
                lineHeight: 1,
                padding: 0,
              }}
            >
              &times;
            </button>

            <h3 style={{ margin: '0 0 20px', color: '#6b0f3a', fontSize: '20px' }}>
              {t('faq.title')}
            </h3>

            {items.map((item, i) => (
              <div key={i} style={{ marginBottom: '8px', borderBottom: '1px solid #f0e6eb' }}>
                <button
                  onClick={() => setOpenItem(openItem === i ? null : i)}
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    background: 'none',
                    border: 'none',
                    padding: '12px 0',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#333',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <span>{item.q}</span>
                  <span style={{ color: '#6b0f3a', fontSize: '18px', flexShrink: 0 }}>
                    {openItem === i ? '−' : '+'}
                  </span>
                </button>
                {openItem === i && (
                  <p style={{
                    margin: '0 0 12px',
                    fontSize: '13px',
                    color: '#555',
                    lineHeight: '1.6',
                  }}>
                    {item.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default FAQ;
